const beveragesList = [
  { label: "Americano", value: "Americano" },
  { label: "Latte", value: "Latte" },
  { label: "Green Tea", value: "Green Tea" },
  { label: "Black Tea", value: "Black Tea" },
  { label: "Orange Juice", value: "Orange Juice" },
];

export default beveragesList;
